import * as React from 'react';
import Document from '@/pages/doc/Document';
import { INav } from './types';

const componentInstances = {
    document: React.createElement(Document),
}

export const navs: Record<string, INav> = {
    '/': {
        page: {
            // component: React.lazy(() => import('@/pages/home/Home')),
            // title: '',
            componentInstance: componentInstances.document,
        },
        key: 'home',
        title: 'Home',
        hidden: true,
    },
    '/:edition/d/*': {
        page: {
            // component: React.lazy(() => import('@/pages/doc/Document')),
            componentInstance: componentInstances.document,
        },
        key: 'doc-key',
        title: 'Document',
        hidden: true,
    },
    '/:prefix/:edition/d/*': {
        page: {
            // component: React.lazy(() => import('@/pages/doc/Document')),
            componentInstance: componentInstances.document,
        },
        key: 'prefix-doc-key',
        title: 'Document',
        hidden: true,
    },
}